import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import { Typography } from "@mui/material";
// Components
import MuiLoader from "../../components/MuiLoader";
import ContentEditor from "../../components/ContentEditor";
import ContentPreview from "../../components/ContentPreview";
import Swal from "sweetalert2";
import CategoryIcon from "@mui/icons-material/Category";
// toastify
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import BorderColorSharpIcon from "@mui/icons-material/BorderColorSharp";
// MUI
import { AppBar, Tabs, Tab } from "@mui/material";
import PropTypes from "prop-types";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";

// MUI
import {
  Avatar,
  Button,
  InputLabel,
  FormControl,
  Select,
  Box,
  Grid,
  Card,
  CardHeader,
  IconButton,
  Menu,
  MenuItem,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AodIcon from "@mui/icons-material/Aod";
import { red, blue, green, purple } from "@mui/material/colors";

import { getAllSkillAudio, saveAllSkillAudio } from "./AudioLabelingThunk";

import {
  getTeacherBaselineFlnThunk,
  getTeacherBaselineEceThunk,
  getTeacherBaselineCommunityThunk,
  deleteTeacherBaselineThunk,
} from "../FlnTopics/FlnTopicsThunk";

import {
  getTeacherBaselineFlnThunkSkill,
  getTeacherBaselinePgeThunkSkill,
  getTeacherBaselineEceThunkSkill,
} from "../FlnSkill/FlnSkillThunk";

// Components
import MuiHeader from "../../components/MuiHeader";
// import TemplateMaster from "../template-master/TemplateMaster";
import FlnTemplate from "../template-master/FlnTemplate";
import api from "../../api/api";
import QuizTemplete from "../quiz_template/QuizTemplete";
// import { clear_data_skill } from "../FlnSkills/FlnSkillsSlice";
import { clear_data_skill } from "../FlnSkill/FlnSkillSlice";
import { clearData } from "../FlnTopics/FlnTopicsSlice";

// import Quiz from "../quiz_template/Quiz";
// import { setTopicId, setTopicName, setOption } from "./FlnActivitySlice";

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const a11yProps = (index) => {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
};

const AudioLabeling = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [tabIndex, setTabIndex] = useState(0);

  // To create Topic
  const navigateToTopic = () => {
    setActivityType("");
    setProgram("");
    setClas("");
    setLevel("");
    setSubject("");
    setSkill([]);
    dispatch(clear_data_skill());
    navigate("/flntopic");
  };

  // To create Skill
  const navigateToSkill = () => {
    setActivityType("");
    setProgram("");
    setClas("");
    setLevel("");
    setSubject("");
    setSkill([]);
    dispatch(clearData());
    navigate("/flnSkill");
  };

  const onTabChange = (event, index) => {
    setTabIndex(index);
  };

  const onTabIndexChange = (index) => {
    setTabIndex(index);
  };

  // ------------ Grid gallery view -----------
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  // ---------------------------------------------
  // --------- options for dropdowns ---------
  const language_select_option_list = [
    { id: 0, value: "od", text: "ଓଡିଆ" },
    { id: 1, value: "en", text: "English" },
  ];

  const usertype_select_option_list = [
    { id: 0, value: "fellow", text: "Fellow" },
    { id: 1, value: "anganwadi", text: "Anganwadi" },
    { id: 2, value: "school", text: "School" },
  ];
  const correct_option_list = [
    { id: 0, value: 1, text: "Beginner" },
    { id: 1, value: 2, text: "Progressing" },
    { id: 2, value: 3, text: "Proficient" },
    { id: 2, value: 4, text: "Advanced" },
  ];

  const assessmentType_select_option_list = [
    { id: 0, value: "formative", text: "Formative Assessment" },
    { id: 1, value: "summative", text: "Summative Assessment" },
  ];

  const activitytype_select_option_list = [
    { id: 0, value: "fln", text: "FLN Activity" },
    { id: 1, value: "pge", text: "PGE Activity" },
    { id: 2, value: "ece", text: "ECE Activity" },
  ];

  const program_select_option_list = [
    { id: 0, value: "pge", text: "PGE" },
    { id: 1, value: "ece", text: "ECE" },
  ];

  const clas_select_option_list = [
    { id: 0, value: 1, text: "ଶ୍ରେଣୀ ୧" },
    { id: 1, value: 2, text: "ଶ୍ରେଣୀ ୨" },
    { id: 2, value: 3, text: "ଶ୍ରେଣୀ ୩" },
    { id: 3, value: 4, text: "ଶ୍ରେଣୀ ୪" },
    { id: 4, value: 5, text: "ଶ୍ରେଣୀ ୫" },
    { id: 5, value: 6, text: "ଶ୍ରେଣୀ ୬" },
    { id: 6, value: 7, text: "ଶ୍ରେଣୀ ୭" },
    { id: 7, value: 8, text: "ଶ୍ରେଣୀ ୮" },
  ];
  const level_select_option_list = [
    { id: 0, value: 1, text: "Level 1 (Age 3-4 Years)" },
    { id: 1, value: 2, text: "Level 2 (Age 4-5 Years)" },
    { id: 2, value: 3, text: "Level 3 (Balvatika)" },
  ];
  const fln_level_select_option_list = [
    // { id: 0, value: "1", text: "Level 1 (Age 3-4 Years)" },
    // { id: 1, value: "2", text: "Level 2 (Age 4-5 Years)" },
    { id: 0, value: 3, text: "Level 3 (Balvatika)" },
  ];

  const subject_select_option_list = [
    { id: 0, value: "foundationalLiteracy", text: "Foundational Literacy" },
    { id: 1, value: "foundationalNumeracy", text: "Foundational Numeracy" },
  ];

  const subjects_select_option_list = [
    { id: 0, value: "maths", text: "Math" },
    { id: 1, value: "odia", text: "Odia" },
    { id: 2, value: "english", text: "English" },
    { id: 3, value: "evs", text: "E.V.S." },
  ];

  // ------------------------------------------------------------

  const languages = useSelector((state) => state.FlnActivitySlice.language);
  const [language, setLanguage] = useState("od");
  const [usertype, setUsertype] = useState("fellow");
  const [marking, setMarking] = useState("");
  console.log("marking===========>", marking);
  const [assessmentType, setAssessmentType] = useState("");
  console.log("assessmentType", assessmentType);
  const [activityType, setActivityType] = useState("");
  const [modules, setModules] = useState([]);
  const [moduleid, setModuleid] = useState("");
  const [submodules, setSubmodules] = useState([]);
  const [submoduleid, setSubmoduleid] = useState("");
  const [topics, setTopics] = useState([]);
  // const [skillId, setskillId] = useState("");
  // //console.log("skillId----->", skillId);
  const [disable_content_button, setDisable_content_button] = useState(true);
  const [disable_quiz_button, setDisable_quiz_button] = useState(true);

  const [contentDetails, setContentDetails] = useState([]);
  const [contents, setContents] = useState([]);
  //console.log("contents", contents);
  const [contentId, setContentId] = useState("");
  const [quiz, setQuizs] = useState([]);
  console.log("quiz---->", quiz);
  const [showUpdate, setShowUpdate] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  const ITEM_HEIGHT = 48;
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [selectedSegment, setSelectedSegment] = useState({});
  const [selectedSegmentQuiz, setSelectedSegmentQuiz] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const openVertMenu = Boolean(anchorEl);
  const [loading, setLoading] = useState(false);

  // -------------- Preview -----------------------
  const [openPreview, setOpenPreview] = useState(false);
  const [previewContenttitle, setPreviewContenttitle] = useState("");
  const [previewContent, setPreviewContent] = useState("");
  // //console.log("previewContent-------->", previewContent.length);
  const [skills, setSkill] = useState([]);
  const [skillId, setskillId] = useState("");
  const [skillName, setSkillName] = useState("");
  //console.log("skillId---->", skillId);
  const [topic, setTopic] = useState([]);
  const [topicId, setTopicId] = useState("");
  const [topicName, setTopicName] = useState("");
  const [openUpdateModal, setOpenUpdateModal] = useState(false);
  const [userid, setUserid] = useState("");
  const [assessData, setAssessData] = useState([]);
  const [answer, setAnswer] = useState("");

  const [quizes, setQuizes] = useState({});
  const openModalonUpdateClick = (item) => {
    setQuizes(item);
    setAssessData(item.assessData);
    console.log("item====================>", item);
    setOpenUpdateModal(true);
  };

  const handleSubmit = () => {
    const body = {
      topicId: topicId,
      skillId: skillId,
      userid: quizes.userid,
      assessData: [
        {
          answer: assessData[0].answer,
          answerType: assessData[0].answerType,
          instructions: assessData[0].instructions,
          question: assessData[0].question,
          questionId: assessData[0].questionId,
          questionMedia: assessData[0].questionMedia,
          questionMediaType: assessData[0].questionMediaType,
          questionOrder: assessData[0].questionOrder,
          remarks: marking,
        },
      ],
    };

    console.log("check1---->", body);
    console.log("check2---->", assessData);
    dispatch(saveAllSkillAudio(body)).then(() => {
      if (activityType === "ece") {
        const body = {
          usertype: "fellow",
          activityType: activityType,
          quizClass: clas ? clas : level,
          // subject,
          program: "ece",
          assessType: assessmentType,
          topicId: topicId,
          skillId: skillId,
        };
        console.log("body=====>", body);
        dispatch(getAllSkillAudio(body)).then((response) => {
          console.log("response====>", response.payload);
          toast.success("successfully Submitted");
          setOpenUpdateModal(false);
          setQuizs(response.payload);
          setLoading(false);
          setDisable_quiz_button(false);
        });
      } else if (activityType === "pge") {
        const body = {
          usertype: "fellow",
          activityType: activityType,
          quizClass: clas ? clas : level,
          subject,
          program: "pge",
          assessType: assessmentType,
          topicId: topicId,
          skillId: skillId,
        };
        console.log("body=====>", body);
        dispatch(getAllSkillAudio(body)).then((response) => {
          console.log("response====>", response.payload);
          setOpenUpdateModal(false);
          toast.success("successfully Submitted");
          setQuizs(response.payload);
          setLoading(false);
          setDisable_quiz_button(false);
        });
      } else if (activityType === "fln") {
        const body = {
          usertype: "fellow",
          activityType: activityType,
          quizClass: clas ? clas : level,
          subject,
          program: program,
          assessType: assessmentType,
          topicId: topicId,
          skillId: skillId,
        };
        console.log("body=====>", body);
        dispatch(getAllSkillAudio(body)).then((response) => {
          console.log("response====>", response.payload);
          setOpenUpdateModal(false);
          toast.success("successfully Submitted");
          setQuizs(response.payload);
          setLoading(false);
          setDisable_quiz_button(false);
        });
      } else {
        console.error("Event object or its properties are undefined");
      }
    });

    setMarking("");
  };

  const closeModalOnUpdateClick = () => {
    setOpenUpdateModal(false);
  };

  const language_select_onchange = (event) => {
    setLanguage(event.target.value);
    setUsertype("");
    setActivityType("");
    setAssessmentType("");
    setContentId("");
    setTopic([]);
    setSkill([]);
    setskillId("");
    setContents([]);
    setQuizs([]);
    setContentDetails([]);
  };
  const usertype_select_onchange = (event) => {
    setUsertype(event.target.value);
    setActivityType("");
    setAssessmentType("");
    setClas("");
    setLevel("");
    setSubject("");
    setContentId("");
    setTopic([]);
    setContents([]);
    setSkill([]);
    setskillId("");
    setContentDetails([]);
  };
  const marking_select_onchange = (event) => {
    setMarking(event.target.value);
  };

  const AssessmentType_select_onchange = (event) => {
    setAssessmentType(event.target.value);
    setProgram("");
    setClas("");
    setLevel("");
    setSubject("");
    setContentId("");
    setTopic([]);
    setContents([]);
    setSkill([]);
    setskillId("");
    setContentDetails([]);
  };

  const activitytype_select_onchange = (event, v) => {
    if (event.target.value != undefined) {
      setActivityType(event.target.value);
      setAssessmentType("");
      setProgram("");
      setClas("");
      setLevel("");
      setSubject("");
      setContentId("");
      setContents([]);
      setTopic([]);
      setSkill([]);
      setskillId("");
      setQuizs([]);
      setContentDetails([]);
      const params = {
        usertype,
        language,
        activityType: event.target.value,
        assessType: assessmentType,
      };

      dispatch(getTeacherBaselineCommunityThunk(params))
        .then((response) => {
          console.log("getTeacherBaselineCommunityThunk", response?.payload);
          setTopic(response?.payload?.length > 0 ? response?.payload : []);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };
  const program_select_onchange = (event) => {
    setProgram(event.target.value);
    setClas("");
    setSkill([]);
    setskillId("");
    setLevel("");
    setTopic([]);
    setContents([]);
    setContentDetails([]);
    setSubject("");
    setQuizs([]);
  };
  const level_select_onchange = (event) => {
    setLevel(event.target.value);
    // setUsertype("");
    setContentId("");
    setContents([]);
    setSkill([]);
    setTopic([]);
    setskillId("");
    setQuizs([]);
    setContentDetails([]);
    setSubject("");
  };
  const clas_select_onchange = (event) => {
    setClas(event.target.value);
    // setUsertype("");
    // setTopics([]);
    setSkill([]);
    setskillId("");
    setContentId("");
    setTopic([]);
    setContents([]);
    setQuizs([]);
    setSubject("");
    setContentDetails([]);
    setSubject("");
  };

  const subject_select_onchange = (event) => {
    setSubject(event.target.value);
    setSkill([]);
    setContents([]);
    setskillId("");
    setTopic([]);
    // setContentId("");
    // setContentDetails([]);
    const params = {
      activityType,
      assessType: assessmentType,
      usertype,
      language,
      program,
      quizClass: level ? level : clas,
      subject: event.target.value,
    };
    dispatch(getTeacherBaselineFlnThunk(params))
      .then((response) => {
        console.log("getTeacherBaselineFlnThunkSkill", response?.payload);
        setTopic(response?.payload?.length > 0 ? response?.payload : []);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const level_select_ece_onchange = (event) => {
    setLevel(event.target.value);
    setSkill([]);
    setskillId("");
    setContents([]);
    setTopic([]);
    const params = {
      activityType,
      assessType: assessmentType,
      usertype,
      language,
      program: "ece",
      quizClass: event.target.value,
    };
    dispatch(getTeacherBaselineEceThunk(params))
      .then((response) => {
        console.log("getTeacherBaselineEceThunk", response?.payload);
        setTopic(response?.payload?.length > 0 ? response?.payload : []);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const topic_select_onchange = (event, value) => {
    // content quiz skill2
    setContent([]);
    setskillId("");
    setQuizs([]);
    setSkill([]);
    if (event && event.target && event.target.value) {
      setTopicId(event.target.value);
      setTopicName(value.props.children);
      const params = { topicId: event.target.value };
      if (activityType === "fln") {
        const params = {
          activityType: "fln",
          usertype: usertype,
          language: "od",
          quizClass: clas ? clas : 3,
          subject,
          program,
        };
        dispatch(getTeacherBaselineFlnThunk(params));
        dispatch(getTeacherBaselineFlnThunkSkill(params))
          .then((response) => {
            console.log("getTeacherBaselineFlnThunkSkill", response?.payload);
            setSkill(response?.payload);
          })
          .catch((error) => {
            console.log(error);
          });
      } else if (activityType === "pge") {
        const paramss = {
          activityType: "pge",
          usertype: usertype,
          language: "od",
          quizClass: clas,
          subject,
          // program,
        };
        // dispatch(getTeacherBaselinePgeThunk(paramss));
        dispatch(getTeacherBaselinePgeThunkSkill(paramss))
          .then((response) => {
            console.log("getTeacherBaselinePgeThunkSkill", response?.payload);
            setSkill(response?.payload);
          })
          .catch((error) => {
            console.log(error);
          });
      } else if (activityType === "ece") {
        const paramss = {
          activityType: "ece",
          usertype: usertype,
          language: "od",
          quizClass: level,
          // subject,
          // program,
        };
        dispatch(getTeacherBaselineEceThunk(paramss));
        dispatch(getTeacherBaselineEceThunkSkill(paramss))
          .then((response) => {
            console.log("getTeacherBaselinePgeThunkSkill", response?.payload);
            setSkill(response?.payload);
          })
          .catch((error) => {
            console.log(error);
          });
      }
    } else {
      // Handle the case when event or its properties are undefined
      console.error("Event object or its properties are undefined");
    }
  };

  const skill_select_onchange = (event, value) => {
    setskillId(event.target.value);
    setSkillName(value.props.children);
    // const params = { topicId: topicId, skillId: event.target.value };
    if (activityType === "ece") {
      const body = {
        usertype: "fellow",
        activityType: activityType,
        quizClass: clas ? clas : level,
        // subject,
        program: "ece",
        assessType: assessmentType,
        topicId: topicId,
        skillId: event.target.value,
      };
      console.log("body=====>", body);
      dispatch(getAllSkillAudio(body)).then((response) => {
        console.log("response====>", response.payload);
        setQuizs(response.payload);
        setLoading(false);
        setDisable_quiz_button(false);
      });
    } else if (activityType === "pge") {
      const body = {
        usertype: "fellow",
        activityType: activityType,
        quizClass: clas ? clas : level,
        subject,
        program: "pge",
        assessType: assessmentType,
        topicId: topicId,
        skillId: event.target.value,
      };
      console.log("body=====>", body);
      dispatch(getAllSkillAudio(body)).then((response) => {
        console.log("response====>", response.payload);
        setQuizs(response.payload);
        setLoading(false);
        setDisable_quiz_button(false);
      });
    } else if (activityType === "fln") {
      const body = {
        usertype: "fellow",
        activityType: activityType,
        quizClass: clas ? clas : level,
        subject,
        program: program,
        assessType: assessmentType,
        topicId: topicId,
        skillId: event.target.value,
      };
      console.log("body=====>", body);
      dispatch(getAllSkillAudio(body)).then((response) => {
        console.log("response====>", response.payload);
        setQuizs(response.payload);
        setLoading(false);
        setDisable_quiz_button(false);
      });
    } else {
      console.error("Event object or its properties are undefined");
    }
  };

  // -------------- Editor -----------------------

  const [content, setContent] = useState();

  const [questionId, setQuestionId] = useState("");
  const [program, setProgram] = useState("");
  const [level, setLevel] = useState("");
  const [clas, setClas] = useState(0);
  const [subject, setSubject] = useState("");

  return (
    <>
      <MuiHeader header="Audio Labeling" />
      <div>
        <Grid container spacing={2} alignItems="center">
          <Grid item>
            <FormControl sx={{ m: 1 }} style={{ width: "130px" }} size="small">
              <InputLabel id="demo-select-small">Language</InputLabel>
              <Select
                labelId="demo-select-small"
                id="demo-select-small"
                value={language}
                label="Language"
                onChange={language_select_onchange}
              >
                <MenuItem value="">None</MenuItem>
                {language_select_option_list.map((option) => (
                  <MenuItem key={option.id} value={option.value}>
                    {option.text}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item>
            <FormControl sx={{ m: 1 }} style={{ width: "130px" }} size="small">
              <InputLabel id="demo-select-small">Usertype</InputLabel>
              <Select
                labelId="demo-select-small"
                id="demo-select-small"
                value={usertype}
                label="Language"
                onChange={usertype_select_onchange}
              >
                <MenuItem value="">None</MenuItem>
                {language &&
                  usertype_select_option_list.map((option) => (
                    <MenuItem key={option.id} value={option.value}>
                      {option.text}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item>
            <FormControl sx={{ m: 1 }} style={{ width: "130px" }} size="small">
              <InputLabel id="demo-select-small">Activity type</InputLabel>
              <Select
                labelId="demo-select-small"
                id="demo-select-small"
                value={activityType}
                label="ActivityType"
                onChange={activitytype_select_onchange}
              >
                <MenuItem value="">None</MenuItem>
                {activitytype_select_option_list.map((option) => (
                  <MenuItem key={option.id} value={option.value}>
                    {option.text}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          {/* {["pge", "ece", "fln"].includes(activityType) ? ( */}
          <Grid item>
            <FormControl sx={{ m: 1 }} style={{ width: "130px" }} size="small">
              <InputLabel id="demo-select-small">AssessType</InputLabel>
              <Select
                labelId="demo-select-small"
                id="demo-select-small"
                value={assessmentType}
                label="AssessType"
                onChange={AssessmentType_select_onchange}
              >
                <MenuItem value="">None</MenuItem>
                {language &&
                  usertype &&
                  assessmentType_select_option_list.map((option) => (
                    <MenuItem key={option.id} value={option.value}>
                      {option.text}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid>
          {/* ) : null} */}

          {activityType === "fln" ? (
            <>
              <Grid item>
                <FormControl
                  sx={{ m: 1 }}
                  style={{ width: "130px" }}
                  size="small"
                >
                  <InputLabel id="demo-select-small">Program</InputLabel>
                  <Select
                    labelId="demo-select-small"
                    id="demo-select-small"
                    value={program}
                    label="Program"
                    onChange={program_select_onchange}
                  >
                    <MenuItem value="">None</MenuItem>
                    {program_select_option_list.map((option) => (
                      <MenuItem key={option?.id} value={option?.value}>
                        {option?.text}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              {program === "pge" ? (
                <>
                  <Grid item>
                    <FormControl
                      sx={{ m: 1 }}
                      style={{ width: "130px" }}
                      size="small"
                    >
                      <InputLabel id="demo-select-small">Class</InputLabel>
                      <Select
                        labelId="demo-select-small"
                        id="demo-select-small"
                        value={clas}
                        label="Class"
                        onChange={clas_select_onchange}
                      >
                        <MenuItem value="">None</MenuItem>
                        {clas_select_option_list.map((option) => (
                          <MenuItem key={option?.id} value={option?.value}>
                            {option?.text}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item>
                    <FormControl
                      sx={{ m: 1 }}
                      style={{ width: "130px" }}
                      size="small"
                    >
                      <InputLabel id="demo-select-small">Subject</InputLabel>
                      <Select
                        labelId="demo-select-small"
                        id="demo-select-small"
                        value={subject}
                        label="Subject"
                        onChange={subject_select_onchange}
                      >
                        <MenuItem value="">None</MenuItem>
                        {language &&
                          usertype &&
                          activityType &&
                          program &&
                          clas &&
                          subject_select_option_list.map((option) => (
                            <MenuItem key={option?.id} value={option?.value}>
                              {option?.text}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item>
                    <FormControl
                      sx={{ m: 1 }}
                      style={{ width: "130px" }}
                      size="small"
                    >
                      <InputLabel id="demo-select-small">Topic</InputLabel>
                      <Select
                        labelId="demo-select-small"
                        id="demo-select-small"
                        label="Topic"
                        value={topicId}
                        onChange={topic_select_onchange}
                      >
                        {topic &&
                          topic?.length > 0 &&
                          topic?.map((option) => (
                            <MenuItem
                              key={option?.topicId}
                              value={option?.topicId}
                            >
                              {option?.topicName}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid>
                    <FormControl
                      sx={{ m: 1 }}
                      style={{ width: "130px" }}
                      size="small"
                    >
                      <InputLabel id="demo-select-small">Skill</InputLabel>
                      <Select
                        labelId="demo-select-small"
                        id="demo-select-small"
                        value={skillId}
                        label="Skill"
                        onChange={skill_select_onchange}
                      >
                        <MenuItem>None</MenuItem>
                        {skills &&
                          skills?.length > 0 &&
                          skills?.map((option) => (
                            <MenuItem
                              key={option?.skillId}
                              value={option?.skillId}
                            >
                              {option?.skillName}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </>
              ) : program === "ece" ? (
                <>
                  <Grid item>
                    <FormControl
                      sx={{ m: 1 }}
                      style={{ width: "130px" }}
                      size="small"
                    >
                      <InputLabel id="demo-select-small">Level</InputLabel>
                      <Select
                        labelId="demo-select-small"
                        id="demo-select-small"
                        value={level}
                        label="Level"
                        onChange={level_select_onchange}
                      >
                        <MenuItem value="">None</MenuItem>
                        {fln_level_select_option_list.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.text}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item>
                    <FormControl
                      sx={{ m: 1 }}
                      style={{ width: "130px" }}
                      size="small"
                    >
                      <InputLabel id="demo-select-small">Subject</InputLabel>
                      <Select
                        labelId="demo-select-small"
                        id="demo-select-small"
                        value={subject}
                        label="Subject"
                        onChange={subject_select_onchange}
                      >
                        <MenuItem value="">None</MenuItem>
                        {language &&
                          usertype &&
                          activityType &&
                          program &&
                          level &&
                          subject_select_option_list.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                              {option.text}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item>
                    <FormControl
                      sx={{ m: 1 }}
                      style={{ width: "130px" }}
                      size="small"
                    >
                      <InputLabel id="demo-select-small">Topic</InputLabel>
                      <Select
                        labelId="demo-select-small"
                        id="demo-select-small"
                        value={topicId}
                        label="Topic"
                        onChange={topic_select_onchange}
                      >
                        {topic &&
                          topic?.length > 0 &&
                          topic?.map((option) => (
                            <MenuItem
                              key={option?.topicId}
                              value={option?.topicId}
                            >
                              {option?.topicName}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid>
                    <FormControl
                      sx={{ m: 1 }}
                      style={{ width: "130px" }}
                      size="small"
                    >
                      <InputLabel id="demo-select-small">Skill</InputLabel>
                      <Select
                        labelId="demo-select-small"
                        id="demo-select-small"
                        value={skillId}
                        label="Skill"
                        onChange={skill_select_onchange}
                      >
                        <MenuItem>None</MenuItem>
                        {skills &&
                          skills?.length > 0 &&
                          skills?.map((option) => (
                            <MenuItem
                              key={option?.skillId}
                              value={option?.skillId}
                            >
                              {option?.skillName}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </>
              ) : null}
            </>
          ) : activityType === "pge" ? (
            <>
              <Grid item>
                <FormControl
                  sx={{ m: 1 }}
                  style={{ width: "130px" }}
                  size="small"
                >
                  <InputLabel id="demo-select-small">Class</InputLabel>
                  <Select
                    labelId="demo-select-small"
                    id="demo-select-small"
                    value={clas}
                    label="Class"
                    onChange={clas_select_onchange}
                  >
                    <MenuItem value="">None</MenuItem>
                    {clas_select_option_list.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.text}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item>
                <FormControl
                  sx={{ m: 1 }}
                  style={{ width: "130px" }}
                  size="small"
                >
                  <InputLabel id="demo-select-small">Subject</InputLabel>
                  <Select
                    labelId="demo-select-small"
                    id="demo-select-small"
                    value={subject}
                    label="Subject"
                    onChange={subject_select_onchange}
                  >
                    <MenuItem value="">None</MenuItem>
                    {subjects_select_option_list.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.text}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item>
                <FormControl
                  sx={{ m: 1 }}
                  style={{ width: "130px" }}
                  size="small"
                >
                  <InputLabel id="demo-select-small">Topic</InputLabel>
                  <Select
                    labelId="demo-select-small"
                    id="demo-select-small"
                    value={topicId}
                    label="Topic"
                    onChange={topic_select_onchange}
                  >
                    {topic &&
                      topic.length > 0 &&
                      topic.map((option) => (
                        <MenuItem key={option.topicId} value={option?.topicId}>
                          {option.topicName}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid>
                <FormControl
                  sx={{ m: 1 }}
                  style={{ width: "130px" }}
                  size="small"
                >
                  <InputLabel id="demo-select-small">Skill</InputLabel>
                  <Select
                    labelId="demo-select-small"
                    id="demo-select-small"
                    value={skillId}
                    label="Skill"
                    onChange={skill_select_onchange}
                  >
                    <MenuItem>None</MenuItem>
                    {skills &&
                      skills?.length > 0 &&
                      skills?.map((option) => (
                        <MenuItem key={option?.skillId} value={option?.skillId}>
                          {option?.skillName}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Grid>
            </>
          ) : activityType === "ece" ? (
            <>
              <Grid item>
                <FormControl
                  sx={{ m: 1 }}
                  style={{ width: "130px" }}
                  size="small"
                >
                  <InputLabel id="demo-select-small">Level</InputLabel>
                  <Select
                    labelId="demo-select-small"
                    id="demo-select-small"
                    value={level}
                    label="Level"
                    onChange={level_select_ece_onchange}
                  >
                    <MenuItem value="">None</MenuItem>
                    {level_select_option_list.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.text}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item>
                <FormControl
                  sx={{ m: 1 }}
                  style={{ width: "130px" }}
                  size="small"
                >
                  <InputLabel id="demo-select-small">Topic</InputLabel>
                  <Select
                    labelId="demo-select-small"
                    id="demo-select-small"
                    value={topicId}
                    label="topic"
                    onChange={topic_select_onchange}
                  >
                    {topic &&
                      topic.length > 0 &&
                      topic.map((option, index) => (
                        <MenuItem key={option.index} value={option?.topicId}>
                          {option.topicName}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item>
                <FormControl
                  sx={{ m: 1 }}
                  style={{ width: "130px" }}
                  size="small"
                >
                  <InputLabel id="demo-select-small">Skill</InputLabel>
                  <Select
                    labelId="demo-select-small"
                    id="demo-select-small"
                    value={skillId}
                    label="Skill"
                    onChange={skill_select_onchange}
                  >
                    <MenuItem>None</MenuItem>
                    {skills &&
                      skills?.length > 0 &&
                      skills?.map((option) => (
                        <MenuItem key={option?.skillId} value={option?.skillId}>
                          {option?.skillName}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Grid>
            </>
          ) : null}
        </Grid>
        <table
          style={{
            width: "100%",
            height: "40%",
            marginTop: "3%",
            border: "solid 1px blue",
          }}
        >
          {quiz?.length > 0 ? (
            <thead>
              <tr>
                <th style={{ width: "10%" }}>Sl no.</th>
                <th style={{ width: "30%" }}>Student Name</th>
                {/* <th>Contact</th> */}
                <th style={{ width: "20%" }}>Question</th>
                <th style={{ width: "30%" }}>Answer</th>
                <th style={{ width: "30%" }}>Remark</th>
                <th style={{ width: "10%" }}>Action</th>
              </tr>
            </thead>
          ) : null}

          <tbody style={{ marginTop: "10%" }}>
            {quiz &&
              quiz?.map((item, index) =>
                item.assessData?.map((assess, i) => (
                  <tr>
                    <td style={{ width: "10%", paddingLeft: "4%" }}>
                      {index + 1}
                    </td>
                    <td style={{ width: "30%", paddingLeft: "13%" }}>
                      {item.studentname}
                    </td>
                    <td style={{ width: "20%", paddingLeft: "7%" }}>
                      {/* {assess.question} */}
                      {assess.question !== "" ? assess.question : "NA"}
                    </td>
                    <td
                      style={{
                        width: "30%",
                        paddingLeft: !assess.answer ? "13%" : null,
                      }}
                    >
                      {assess.answer === "skip" ? (
                        <p> Skip</p>
                      ) : !assess.answer ? (
                        <p>NA</p>
                      ) : assess.answer ? (
                        <audio controls>
                          <source src={assess.answer} />
                        </audio>
                      ) : null}
                    </td>

                    <td style={{ width: "30%", paddingLeft: "4%" }}>
                      {assess.remarks}
                    </td>
                    <td style={{ width: "10%" }}>
                      <Button onClick={() => openModalonUpdateClick(item)}>
                        <BorderColorSharpIcon />
                      </Button>
                    </td>
                  </tr>
                ))
              )}
          </tbody>
        </table>
      </div>

      {quiz.length === 0 ? (
        <h4 style={{ color: "royalblue" }}>No Quiz Available</h4>
      ) : null}

      <Modal open={openUpdateModal} onClose={closeModalOnUpdateClick}>
        <Box sx={style}>
          <FormControl size="small" style={{ width: "50%", marginLeft: "20%" }}>
            <InputLabel id="demo-select-small">Marking</InputLabel>
            <Select
              labelId="demo-select-small"
              id="demo-select-small"
              value={marking}
              label="Marking"
              onChange={marking_select_onchange}
            >
              <MenuItem value="">None</MenuItem>
              {correct_option_list.map((option) => (
                <MenuItem key={option.id} value={option.value}>
                  {option.text}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <div style={{ display: "flex", justifyContent: "space-around" }}>
            <Button
              variant="contained"
              sx={{
                width: 70,
                marginTop: 2,
                marginBottom: 1,
                marginRight: 1,
              }}
              onClick={closeModalOnUpdateClick}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              sx={{
                width: 70,
                marginTop: 2,
                marginBottom: 1,
                marginRight: 1,
              }}
              // onClick={handleCommunityTopicSave}
              onClick={handleSubmit}
            >
              Save
            </Button>
          </div>
        </Box>
      </Modal>

      {/* Loader */}
      <MuiLoader open={loading} />

      {/* Toaster */}
      <ToastContainer />
    </>
  );
};

export default AudioLabeling;

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
